import { isLegalPage } from "./legalPages";

/**
 * Which paths draw the public landing surface.
 *
 * The canonical origin serves the landing at `/`, while every other route is
 * an application route. `/landing` carries the same page for previews and is
 * kept out of search indexes.
 */

/** The landing itself, at the root and at the path it can be previewed on. */
const MARKETING_PATHS = ["/", "/landing"];

export function isMarketingPage(pathname: string): boolean {
  const path = pathname.replace(/\/+$/, "") || "/";
  return MARKETING_PATHS.includes(path) || isLegalPage(path);
}
